class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    // In app-mode, use app-top-header instead of sticky-header
    const isAppMode = document.documentElement.classList.contains('app-mode') ||
                      document.body.classList.contains('app-mode');
    this.header = isAppMode
      ? document.querySelector('.app-top-header')
      : document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        const container = document.getElementById(section.id);
        if (!container || !parsedState.sections[section.section]) return;
        container.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

      // Only call reveal() if header is sticky-header (has reveal method)
      // app-top-header doesn't need reveal as it's always visible
      if (this.header && this.header.reveal) {
        this.header.reveal();
      }
      this.open();
      this.persistCartSnapshot(parsedState);
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
    if (document.getElementById('cart-icon-bubble-top')) {
      sections.push({
        id: 'cart-icon-bubble-top',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      });
    }
    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  persistCartSnapshot(parsedState) {
    if (!window.CartSyncStorage || !parsedState || !parsedState.sections) return;

    const sections = {};
    if (parsedState.sections['cart-icon-bubble']) {
      sections['cart-icon-bubble'] = parsedState.sections['cart-icon-bubble'];
    }

    if (!Object.keys(sections).length) return;

    window.CartSyncStorage.save({
      sections,
      item_count: typeof parsedState.item_count === 'number' ? parsedState.item_count : undefined
    });
  }
}

customElements.define('cart-notification', CartNotification);
